import { range } from 'lodash-es';

export function pages(currentPage: number, noOfPages: number): number[] {
    // return array of pages. -1 signals a '..' char
    if (noOfPages <= 4) {
        return range(1, noOfPages + 1);
    }
    const pages: number[] = [];

    pages.push(1);

    if (currentPage <= 4) {
        pages.push(2);
    } else {
        pages.push(-1);
    }

    if (currentPage >= 4 && noOfPages - currentPage >= 1) {
        pages.push(currentPage - 1);
    }

    if (currentPage >= 3 && noOfPages - currentPage >= 2) {
        pages.push(currentPage);
    }

    if (currentPage >= 2 && noOfPages - currentPage >= 3) {
        pages.push(currentPage + 1);
    }

    if (noOfPages - currentPage >= 4) {
        pages.push(-1);
    } else {
        pages.push(noOfPages - 1);
    }

    pages.push(noOfPages);
    return pages;
}
